import Component from 'vue-class-component'
import Vue from 'vue'
import { IUser } from '../../model/user'
import TrustButton from '../buttons/TrustButton.vue'
import feedStore from '../../store/feed/feed-store'
import authStore from '@/store/auth/auth-store';

@Component({
  name: 'userHeader',
  props: ['user'],
  components: { 'trust-button' : TrustButton },
})
export default class UserHeader extends Vue {
  getUser (): IUser {
    return this.$props['user'] as IUser
  }

  get isAuthenticated():boolean {return authStore.isAuthenticated}

  protected viewUserFeed (): void {
    console.log('UserHeader: setting feed to user: %j', this.getUser())
    this.$router.push ({
      path: '/statements',
      query: {uid: (<number>this.getUser().id).toString()}
    })
    feedStore.dispatchSetFeedUser(this.getUser())
  }

}
